export var InputTypes;
(function (InputTypes) {
    InputTypes["START"] = "START";
    InputTypes["END"] = "END";
})(InputTypes || (InputTypes = {}));
export var MASKED_DATE_LENGTH = 10;
